import React from "react";
import { Helmet } from "react-helmet";

import ContactStaticBanner from "../Components/Contact/ContactStaticBanner";
import VangalContactDetails from "../Components/Contact/VangalContactDetails";
import VangalMapSection from "../Components/Contact/VangalMapSection";
import ContactSection from "../Components/ContactSection";

export default function Contact() {
  return (
    <>
      <Helmet>
        <title>Contact Us | Vangal Dairies</title>
        <meta
          name="description"
          content="Get in touch with Vangal Dairies for product enquiries, distribution, partnerships, or support. Contact details, map location, and quick enquiry form available here."
        />
      </Helmet>

      <ContactStaticBanner />
      <ContactSection />
      <VangalContactDetails />
      <VangalMapSection />
    </>
  );
}
